import Axios, { AxiosInstance } from 'axios'
import { ProductAdminSettingsInterface } from '../interfaces/ProductAdminSettings.interface'
import { apiConstants, ApiConstantsInterface } from '../constants/api.constants'

interface ProductSettingsServiceInterface {
  getProductAdminSettings(productId: number): Promise<ProductAdminSettingsInterface>
}

class ProductSettingsService implements ProductSettingsServiceInterface {
  protected axios: AxiosInstance

  protected config: ApiConstantsInterface

  constructor(config: ApiConstantsInterface) {
    this.config = config
    this.axios = Axios.create({
      baseURL: config.baseUrl,
    })
  }

  async getProductAdminSettings(productId: number): Promise<ProductAdminSettingsInterface> {
    const response = await this.axios.get(`${this.config.productSettings}/${productId}`)
    return response.data
  }

  async updateProductAdminSettings(
    productId: number,
    settings: ProductAdminSettingsInterface
  ): Promise<ProductAdminSettingsInterface> {
    const response = await this.axios.post(`${this.config.productSettings}/${productId}`, settings)
    return response.data
  }
}

const productSettingsService = new ProductSettingsService(apiConstants)
export { productSettingsService }
